<template>
  <div id="barsh">
    <div class="barsh-content">
      <div id="barsh1" style="float: left; height: 100%; width: 77%"></div>
      <div style="float: left; width: 11%; height: 100%">
        <div style="width: 100%; height: 50%">
          <div class="text3 div-box-2">
            <span class="div-box-title">{{
              locale("Predicted energy(tce)", "预测能耗(吨标煤)")
            }}</span>
            <br />
            <span class="div-box-text-2" style="color: #70df00">{{
              dataAll3[0]
            }}</span>
            <br />
          </div>
        </div>
        <div style="width: 100%" class="div-box">
          <span class="div-box-title"
            >{{ locale("Predicted tce/¥10K", "预测万元产值能耗") }}<br />{{
              locale(" ", "(吨/万元)")
            }}</span
          >
          <br />
          <span class="div-box-text" style="color: #70df00">{{
            dataAll3[2]
          }}</span>
          <br />
        </div>
      </div>
      <div style="float: left; width: 10%; height: 100%">
        <div style="width: 100%; height: 50%">
          <div class="text3 div-box-2">
            <span class="div-box-title">
              {{ locale("Target energy(tce)", "目标能耗(吨标煤)") }}</span
            >
            <br />
            <span class="div-box-text-2" style="color: #1e90ff">{{
              dataAll3[1]
            }}</span>
            <br />
          </div>
        </div>
        <div style="width: 100%" class="div-box">
          <span class="div-box-title"
            >{{ locale("Target tce/¥10K", "目标万元产值能耗") }}<br />{{
              locale(" ", "(吨/万元)")
            }}</span
          >
          <br />
          <span class="div-box-text" style="color: #1e90ff">{{
            dataAll3[3]
          }}</span>
          <br />
        </div>
      </div>
      <div style="float: left; width: 10%; height: 100%">
        <div style="width: 100%; height: 50%">
          <div class="text3 div-box-2">
            <span class="div-box-title">{{
              locale("pc(%)", "完成率(%)")
            }}</span>
            <br />
            <span id="aa" class="div-box-text-2">{{ dataAll3[4] }}</span>
            <br />
          </div>
        </div>
        <div style="width: 100%" class="div-box">
          <span class="div-box-title"
            >{{ locale("pc(%)", "完成率(%)") }}<br />
          </span>
          <br />
          <span id="bb" class="div-box-text">{{ dataAll3[5] }}</span>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from "echarts";
import request from "../../utils/request";
import { MONTH_NAME } from "../mainPage/area_bu";

export default {
  name: "barsh",
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [],
      dataAll: [],
      dataAll2: [],
      dataAll3: [],
      dataAll4: [],
      WyB: "",
      inntDC: "",
      NowYearTargetValue: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      queryParams: {
        QueryStartMonth: "11",
        QueryYear: 2020
      },
    };
  },
  created() {
    setInterval(this.refreshData(), 30000);
  },
  mounted() {
    // this.testReq1();
    this.NowYearTargetValue = [];
    for (let i = 0; i < MONTH_NAME.length; i++) {
      this.NowYearTargetValue.push(MONTH_NAME[i].label);
    }
  },
  watch: {
    dataset: {
      handler(newName, oldName) {
        this.dataset = newName;
        console.log(newName);
        console.log(oldName);
        console.log("dataset changed");
      },
      immediate: true,
      deep: true,
    },
    props: {
      value4: {
        type: String,
      },
      value: {
        type: String,
      },
    },
  },
  methods: {
    initCharts() {
      var myChart1 = echarts.init(document.getElementById("barsh1"));
      var that = this;
      var option = {
        tooltip: {
          trigger: "axis",
          formatter:
            "{b}<br />{a0}: {c0}<br />{a5}: {c5}<br />{a3}: {c3}<br />{a4}: {c4}",
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          textStyle: {
            color: "#fff",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 16,
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "20%",
          containLabel: true,
        },
        legend: {
          x: "center",
          bottom: 60,
          top: 20,
          itemGap: 16,
          itemWidth: 18,
          itemHeight: 10,
          textStyle: {
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            color: "#ffffff",
            fontSize: 16,
          },
          data: [
            {
              name: this.locale("Energy target", "能耗目标"),
            },
            {
              name: this.locale("Energy consumption", "能耗实际"),
            },
         
            {
              name: this.locale("tce/¥10K target", "万元产值能耗目标"),
            },
            {
              name: this.locale("tce/¥10K actual", "万元产值能耗实际"),
            },
          ],
        },
        xAxis: [
          {
            type: "category",
            data: this.NowYearTargetValue,
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 16,
              },
              //rotate: 50
            },
            axisTick: {
              show: true,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.locale("tce", "吨标准煤"),
            nameTextStyle: {
              color: "#fff",
              fontSize: 16,
            },
            max: function (value) {
              return Math.round(value.max) * 2;
            },
            splitNumber: 3,
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 16,
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#fff"],
                opacity: 0.06,
              },
            },
          },
          {
            type: "value",
            name: this.locale("tce/¥10K", "万元产值能耗"),
            nameTextStyle: {
              color: "#fff",
              fontSize: 16,
            },
            min: function (value) {
              console.log(value.max * -1);
              return value.max * -1;
            },
            splitNumber: 4,
            axisLabel: {
              textStyle: {
                color: function (value) {
                  if (value <= 0) {
                    return "transparent";
                  }
                  return "#fff";
                },
                fontStyle: "normal",
                fontFamily: "微软雅黑",
                fontSize: 16,
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#fff"],
                opacity: 0.06,
              },
            },
          },
        ],
        series: [
          {
            name: this.locale("Energy target", "能耗目标"),
            type: "bar",
            data: this.dataset[1],
            barWidth: 10,
            barGap: 0,
            color: "#1E90FF",
            itemStyle: {
              normal: {
                show: true,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#1E90FF",
                  },
                  {
                    offset: 1,
                    color: "#1E90FF",
                  },
                ]),
                borderWidth: 0,
              },
            },
          },
          {
            name: this.locale("Energy consumption", "能耗实际"),
            type: "bar",
            color: "#70DF00",
            stack: "能耗实际",
            data: this.dataset[12],
            barWidth: 9,
            barGap: 0,
            itemStyle: {
              normal: {
                show: true,
                color: function (params) {
                  var colorList = that.dataset[4];
                  return colorList[params.dataIndex];
                },
                borderWidth: 0,
              },
            },
          },
          {
            name: this.locale("上升", "上升"),
            type: "bar",
            stack: "能耗实际",
            data: this.dataset[13],
            color: "red",

            itemStyle: {
              emphasis: {
                barBorderRadius: [5, 5, 0, 0],
              },
              normal: {
                show: true,
                barBorderRadius:  [5, 5, 0, 0],
                borderWidth: 0,
              },
            },
          },
          {
            name: this.locale("tce/¥10K actual", "万元产值能耗实际"),
            type: "line",
            data: this.dataset[2],
            color: "#70DF00",
            symbol: "circle", //折线点设置为实心点
            symbolSize: 4, //折线点的大小
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                show: true,
                color: function (params) {
                  var colorList = that.dataset[6];
                  return colorList[params.dataIndex];
                },
                barBorderRadius: 50,
                borderWidth: 0,
              },
            },
          },
          {
            name: this.locale("tce/¥10K target", "万元产值能耗目标"),
            type: "line",
            data: this.dataset[3],
            color: "#1E90FF",
            yAxisIndex: 1,
          },
          {
            name: "能耗实际", // 总数显示，生成一个总数的柱状图，将颜色设为透明，
            type: "bar", // label将位置设备内部底部，造成一个总数显示在
            stack: "sum", // 柱状图上方的假象
            itemStyle: {
              normal: {
                color: "rgba(128, 128, 128, 0)", // 柱状图颜色设为透明
              },
            },
            data: this.dataset[0],
          },
        ],
      };
      myChart1.setOption(option);
    },
    createData1() {
      const { randomExtend } = this;
    },
    refreshData(value) {
      const { refreshChart } = this;
      var that = this;
      if (value === undefined) {
        value = this.queryParams;
      } else {
        this.queryParams = value;
      }
      request({
        url: "GetBarsh/GetValue",
        method: "post",
        data: this.queryParams,
      }).then((response) => {
        var that = this;
        console.log(response);
        that.dataset = response.data.items;
        console.log("时间设置--");
        console.log(that.dataset);
        that.dataAll = response.data.items[5];
        that.dataAll2 = response.data.items[7];
        that.dataAll3 = response.data.items[10];
        var dataAll4 = response.data.items[11];
        that.WyB = (
          parseFloat(that.dataAll[0]) / parseFloat(that.dataAll2[0])
        ).toFixed(4);
        var aa = document.getElementById("aa");
        aa.style.color = dataAll4[0];
        bb.style.color = dataAll4[1];
        that.inntDC = that.dataset[9][0];
        this.initCharts();
        console.log(that.dataset);
      });
    },
    goto() {
      this.$router.push("/bscpage1");
    },
  },
  thecolor(params) {
    var colorList = "";
    if (params.dataIndex > 5) {
      colorList = " #a5a5a5";
    } else {
      colorList = "#009a1c";
    }

    if (params.dataIndex === 0) {
      if (this.legendColor) {
        return "#009a1c"; // 第二次params.dataIndex为0 的情况表示刷新图例的颜色
      } else {
        this.legendColor = true; // 第一次params.dataIndex为0 的情况
      }
    }

    return colorList;
  },
};
</script>
<style lang="less">
#barsh {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #17293d;
  box-sizing: border-box;

  .barsh-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
  }

  .div-box {
    border-left: 5px solid #fcae63;
    padding-left: 10px;
    padding-top: 5px;
    text-align: left;
  }

  .div-box-2 {
    border-left: 5px solid #75e35e;
    padding-left: 10px;
    padding-top: 5px;
    text-align: left;
  }

  .div-box-title {
    color: #ddd;
    font-size: 18px;
    font-weight: bold;
  }

  .div-box-text {
    font-size: 36px;
    font-weight: bold;
    line-height: 60px;
    color: #fcae63;
  }

  .div-box-text-2 {
    font-size: 36px;
    font-weight: bold;
    line-height: 60px;
    color: #75e35e;
  }
}
.text3 {
  text-align: center;
  position: absolute !important;
  top: 25% !important;
  height: 76px;
  margin-top: -38px;
  transform: translateY(-0%);
}
</style>
